export const customerSearchAsOkta = ({
  token,
  clientSlug,
  firstName,
  lastName,
  emailAddress,
  pageNumber,
  pageSize,
}) => ({
  HTTPMethod: "get",
  path: `/sso/admin/users`,
  queryParams: {
    client_slug: clientSlug,
    first_name: firstName ? firstName : undefined,
    last_name: lastName ? lastName : undefined,
    email: emailAddress ? emailAddress : undefined,
    "page[number]": pageNumber ? pageNumber : undefined,
    "page[size]": pageSize ? pageSize : undefined,
  },
  body: null,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
